import { useEffect, useRef } from 'react';

import { GoogleOAuthProvider } from '@react-oauth/google';

import type { GoogleAuthKitConfig, UseAuthStore } from '../types';

function SessionInitializer({ useAuthStore, logPrefix }: { useAuthStore: UseAuthStore; logPrefix: string }) {
  const hasAttemptedRestore = useRef(false);

  useEffect(() => {
    if (hasAttemptedRestore.current) return;
    hasAttemptedRestore.current = true;

    const store = useAuthStore.getState();

    if (store.isAuthenticated) {
      store.initialize();
      return;
    }

    store.restoreSession().then(restored => {
      if (restored) {
        console.info(`${logPrefix} Session restored from cookie`);
      }
      store.initialize();
    });
  }, [useAuthStore, logPrefix]);

  return null;
}

export function createGoogleAuthProvider(useAuthStore: UseAuthStore, config: GoogleAuthKitConfig): React.FC<{ children: React.ReactNode }> {
  const { googleClientId, logPrefix = '[auth]' } = config;

  return function GoogleAuthProvider({ children }) {
    return (
      <GoogleOAuthProvider clientId={googleClientId}>
        <SessionInitializer useAuthStore={useAuthStore} logPrefix={logPrefix} />
        {children}
      </GoogleOAuthProvider>
    );
  };
}
